<template>
  <div class="signUp">
    <heads></heads>
    <div class="container">
      <div class="content">
        <div class="menber box">
          <div class="linetime-box">
            <span class="name">{{lineSchedule.scheduleName? lineSchedule.scheduleName: line.lineTitile}}</span>
            <span class="linetime">出发日期: {{timeFormat(lineSchedule.departDate)}}</span>
          </div>
          <div class="usually">
            <span class="text">请填写真实信息</span>
            <span class="btn pull-right" @click="show()">常用人</span>
          </div>
          <div class="menber-list">
            <div class="add-aontent" v-for="(item,index) in touristInfo" :key="index">
              <div class="add-list">
                <div class="add-item">
                  <el-input placeholder="(与证件名字一致)" v-model="item.name">
                    <template slot="prepend">真实姓名</template>
                  </el-input>
                </div>
                <div class="add-item">
                  <el-input
                    placeholder="(与证件号码一致)"
                    v-model="item.idcard"
                    @blur="handleIdNumberInput(item.idcard,item.idType,index)"
                  >
                    <el-select v-model="item.idType" slot="prepend" placeholder="请选择">
                      <el-option
                        v-for="item in idoptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-input>
                </div>

                <!-- <div class="add-item" v-if="item.idType!=0"> -->
                <div class="add-item">
                  <el-input placeholder="（例如：2020-01-01）" v-model="item.birthday">
                    <template slot="prepend">出生日期</template>
                  </el-input>
                </div>
                <!-- <div class="add-item" v-if="item.idType!=0"> -->
                <div class="add-item">
                  <span class="left-text">性别</span>
                  <div class="right-text">
                    <div class="info">
                      <span
                        @click="item.gender=0"
                        class="select"
                        :class="[item.gender==0 ? 'select-active' : '']"
                      >
                        男
                        <i class="fa fa-mars" aria-hidden="true"></i>
                      </span>
                      <span
                        @click="item.gender=1"
                        class="select"
                        :class="[item.gender==1 ? 'select-active' : '']"
                      >
                        女
                        <i class="fa fa-venus" aria-hidden="true"></i>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="add-item">
                  <el-input placeholder="请输入电话号码" v-model="item.phone">
                    <template slot="prepend">电话号码</template>
                  </el-input>
                </div>
                <div class="add-item add-price">
                  <el-input placeholder="请选择价格" v-model="item.price.linePrice" >
                    <el-select
                      v-model="item.price"
                      value-key="id"
                      slot="prepend"
                      placeholder="请选择"
                      @change="priceChange(item,index)"
                    >
                      <el-option
                        v-for="items in pricelist"
                        :key="items.id"
                        :label="items.priceName"
                        :value="items"
                      ></el-option>
                    </el-select>
                  </el-input>
                </div>
                <div class="add-item">
                  <span class="address-label">集合地点</span>
                 <el-select
                    v-model="item.gatherPlaceId"
                    placeholder="请选择集合地点"
                   class="address"
                   @input="placeChange(item)"
                  >
                  <el-option
                    v-for="item2 in userGatherList[index]"
                    :key="item2.gatherPlaceId.id"
                    :label="item2.gatherPlaceId.gatherPlace"
                    :value="item2.gatherPlaceId.id"
                    ></el-option>
                 </el-select>
                </div>
              </div>
              <div class="itemright" v-if="index>0">
                <span class="reduse" @click="del(index)">
                  <i class="fa fa-window-minimize" aria-hidden="true"></i>
                </span>
              </div>
            </div>

            <div class="menber menber-item add-items" @click="add">
              <i class="fa fa-plus-circle" aria-hidden="true"></i> 添加游客
            </div>

            <div class="other-options">
              <!-- <div class="other-item">
                <span>集合地点：</span>
                <el-select v-model="placeId" placeholder="请选择集合地点" class="address">
                  <el-option
                    v-for="item in gatherlist"
                    :key="item.gatherPlaceId.id"
                    :label="item.gatherPlaceId.gatherPlace"
                    :value="item.gatherPlaceId.id"
                  ></el-option>
                </el-select>
              </div> -->
              <div class="other-item">
                <span>优惠类型：</span>
                <el-select
                  v-if="isdiscountlis"
                  v-model="discountAmount"
                  placeholder="请选择优惠类型"
                  class="monut"
                  value-key="id"
                  @change="getDisCount"
                >
                  <el-option
                    v-for="item in discountlist"
                    :key="item.id"
                    :label="item.discount.discountName"
                    :value="item.discount"
                  ></el-option>
                </el-select>
              </div>
              <div class="price">
                <div class="price-left">
                  <span class="labels">费用详情</span>
                  <span>
                    <el-checkbox v-model="ispoint" @change="pointchange"></el-checkbox>
                    <span class="label">是否使用积分</span>
                  </span>
                </div>
              </div>
              <div class="price-lists" v-if="ispoint">
                <div class="price-items">
                  <span>您的积分：{{member.point}}个</span>
                </div>
                <div class="price-items">
                  <span>本单最多可用积分：{{maxPoints}}个</span>
                </div>
                <div class="price-items">
                  <el-input placeholder="请输入抵扣积分数量" v-model="pointvalue" @blur="blur">
                    <template slot="prepend">使用积分</template>
                  </el-input>
                </div>
                <div class="price-items">
                  <span>积分抵扣：{{discount}}元</span>
                </div>
              </div>
              <div class="price-list">
                <div class="price-item">
                  <span>报名人数:</span>
                  <span class="col">{{number}}人</span>
                </div>
                <div class="price-item">
                  <span>订单价格:</span>
                  <span style="color:red" v-if="allamount<=0">--</span>
                  <span style="color:red" v-else>{{allamount}}</span> 元
                </div>
                <div class="price-item">
                  <span>应付价格:</span>
                  <span style="color:red" v-if="amount<=0">--</span>
                  <span style="color:red" v-else>{{amount}}</span> 元
                </div>
              </div>
              <div class="price">
                <div class="price-left">
                  <span class="labels">联系方式</span>
                </div>
              </div>
              <div class="other-item">
                <el-input placeholder="请输入真实姓名" v-model="aname">
                  <template slot="prepend">联系人</template>
                </el-input>
              </div>
              <div class="other-item">
                <el-input placeholder="请输入联系人电话" v-model="amobile">
                  <template slot="prepend">联系电话</template>
                </el-input>
              </div>
              <div class="price">
                <div class="price-left">
                  <span class="labels">紧急联系人</span>
                </div>
              </div>
              <div class="other-item">
                <el-input placeholder="请输入紧急联系人" v-model="emergencyContact">
                  <template slot="prepend">联系人</template>
                </el-input>
              </div>
              <div class="other-item">
                <el-input placeholder="请输入联系人电话" v-model="emergencyPhone">
                  <template slot="prepend">联系电话</template>
                </el-input>
              </div>
            </div>
            <!-- <div class="price">
              <div class="price-left">
                <span class="labels">支付方式</span>
              </div>
            </div> -->
             <!--  <div class="other-item">
            <span>支付方式： </span> 
              <el-radio-group v-model="payMethod">
                <el-radio
                  v-for="(item,index) in payMethodArray"
                  :key="index"
                  :label="index"
                >{{item}}</el-radio>
              </el-radio-group>
            </div>-->
            <div class="price">
              <div class="price-left">
                <span class="labels">备注</span>
              </div>
            </div>
            <el-input class="textarea" type="textarea" v-model="remark" placeholder="请填写备注信息 (选填)"></el-input>
            <div class="price" v-if="line.isNeedSign == 1">
              <div class="price-left signatureStyle-content">
                <span class="labels signatureStyle" >签名</span>
                <img id='signature' :src="showSignature"  alt />
              </div>
            </div>
            <div class="agreement" style="margin-top:70px">
              <div class="agreement-left">
                <span @click="getAgreement()" >
                  <el-checkbox v-model="checked" disabled style=""></el-checkbox>
                  我已经阅读并同意
                  <span
                    style="color: #007741;cursor: pointer;"
                  >{{`《${serviceAgreements.protocolName}》`}}</span>
                </span>
              </div>
              <!-- <div class="pay-method">
                支付方式：
                <i class="fa fa-weixin" aria-hidden="true"></i> 
                <img src="../../../static/images/weixin_pay.png" alt v-show="payMethod === 0" />
                <img src="../../../static/images/zhifubao_pay.png" alt v-show="payMethod === 1" />
              </div>-->
              <div class="agreement-right">
                <span class="total">
                  总费用：
                  <span class="col" v-if="amount<=0">--</span>
                  <span class="col" v-else>{{amount}}元</span>
                </span>
                <div class="buttoms" @click="createOrder()">立即支付</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <wxpay
        :open="wxpayDialog"
        :src="wxpaysrc"
        :wechatamount="wechatamount"
        @close="closeWxpay"
        :method="payMethod"
      ></wxpay>

      <el-dialog
        title="常用联系人"
        :visible.sync="dialogVisible"
        width="50%"
        :before-close="handleClose"
      >
        <div class="edit-info" @click="addtour()">{{isadd?'取消':'添加'}}</div>
        <div class="tour-content" v-if="!isadd">
          <div class="list" v-for="(item,index) in pageArray" :key="index">
            <div class="info-left">
              <el-checkbox v-model="item.checked" @change="checked=>checkRow(item.checked, item)"></el-checkbox>
            </div>
            <div class="touitem">
              <div class="tou-top">
                <div class="top-left">
                  <i class="fa fa-user-circle-o" aria-hidden="true"></i>
                  <span class="namess">{{item.contactName}}</span>
                  <i class="fa fa-mars" aria-hidden="true" v-if="item.gender==0"></i>
                  <i class="fa fa-venus" aria-hidden="true" v-else></i>
                  <span class="default" v-if="item.isdefault==1">默认</span>
                </div>
                <div class="top-right">
                  <i class="fa fa-mobile" aria-hidden="true"></i>
                  <span class="phone">{{item.mobile}}</span>
                </div>
              </div>
              <div class="tou-bottom">
                <div class="top-lefts">
                  <i class="fa fa-id-card-o" aria-hidden="true"></i>
                  <span v-if="item.idType==0">身份证</span>
                  <span v-if="item.idType==1">护照</span>
                  <span v-if="item.idType==2">其他</span>
                  ：{{item.idNumber}}
                </div>
                <div class="top-right">出生日期：{{item.birthday}}</div>
              </div>
              <div class="btn-item">
                <div class="posi">
                  <span class="btn1" @click="toEditInfo(item.id)">编辑</span>
                  <span class="btn1" @click="deleteFavorites(item.id)">删除</span>
                </div>
              </div>
            </div>
          </div>
          <div class="pagination">
            <el-pagination
              background
              layout="prev, pager, next"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="pageNumber"
              :page-size="4"
              :total="total"
            ></el-pagination>
          </div>
        </div>
        <div class="edit" v-else>
          <div class="edit-item">
            <span class="edit-text">真实姓名</span>
            <el-input v-model="contactName" placeholder="请输入您的姓名"></el-input>
          </div>
          <div class="edit-item">
            <span class="edit-text">手机号码</span>
            <el-input v-model="mobile" placeholder="请输入您的手机号码"></el-input>
          </div>
          <div class="edit-item">
            <span class="edit-text">证件类型</span>
            <el-radio v-model="idType" label="0">身份证</el-radio>
            <el-radio v-model="idType" label="1">护照</el-radio>
            <el-radio v-model="idType" label="2">其他</el-radio>
          </div>
          <div class="edit-item">
            <span class="edit-text">证件号</span>
            <el-input v-model="idNumber" placeholder="请输入您的证件号"></el-input>
          </div>
          <div class="edit-item">
            <span class="edit-text">性别</span>
            <el-radio v-model="gender" label="0">男</el-radio>
            <el-radio v-model="gender" label="1">女</el-radio>
          </div>
          <div class="edit-item">
            <span class="edit-text">出生日期</span>
            <el-date-picker v-model="birthday" type="date" placeholder="选择日期"></el-date-picker>
          </div>
          <div class="edit-item">
            <span class="edit-text">是否默认</span>
            <el-switch v-model="isdefault" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" v-if="!isadd" @click="dialogVisible = false">确 定</el-button>
          <el-button type="success" v-if="isadd" @click="editInfo">保存</el-button>
        </span>
      </el-dialog>
    </div>
    <el-dialog
      title="用户协议"
      :visible.sync="isAgreement"
      width="60%"
      :before-close="handleCloseAgreement"
    >
      <div class="diacontent">
        <div
            v-html="serviceAgreements.protocolMessages"
            ref="protocolMessages"
          ></div>
          <div class="disbtnlist">
            <div class="dis-btn btn-col" @click="agree(1)">不同意</div>
            <div class="dis-btn" @click="agree(2)">同意</div>
      </div>
      </div>
      
    </el-dialog>
    <el-dialog
      title="签名"
      :visible.sync="isSignature"
      width="70%" 
      style="z-index:1000!important;"
    >
          <div class="diacontent" style="height:380px;box-sizing:border-box">
            <vue-esign ref="esign"  :isCrop="isCrop" :lineWidth="lineWidth" 
            :lineColor="lineColor" :bgColor.sync="bgColor" class="writeStyle"/>          
            <div class="disbtnlist">
          	<button class="btn-reverse"  @click="back()" style="margin: 10px 5px;">关闭</button>
            <button class="btn-reverse"  @click="reset()" style="margin: 10px 5px;">重签</button>
	          <button class="dis-btn" id="yes" @click="submitSignature()" style="margin: 10px 5px;">提交</button>
          </div>
        </div>
    </el-dialog>
    <!-- <div id="qrcode" ref="qrcode"></div> -->
    <homeFoots></homeFoots>
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import banners from "@/components/comment/banners.vue";
import wxpay from "../wxpay/index.vue";
import { fomateDate , timeFormat} from "@/util/util.js";
// import QRCode from 'qrcodejs2'
import qs from "qs";
import axios from "axios";
export default {
  name: "signUp",
  data() {
    return {
      //常用联系人
      dialogVisible: false,
      checkeds: false,
      totalPage: 0,
      pageArray: "",
      lineWidth: 6,
      isCreateOrder: false,
      lineColor: '#000000',
      bgColor: '',
      isCrop: false,
      pageNumber: 1,
      isSignature: false,
      showSignature: '',
      signatureId: '',
      total: 0,
      isadd: false,
      //用户协议
      isAgreement: false,
      contactName: "",
      birthday: "2015-11-12",
      gender: "0",
      isdefault: true,
      mobile: "",
      idNumber: "",
      idType: "0",
      id: "",
      //是否使用积分
      ispoint: false,
      pointvalue: 0,
      aname: "", //联系人姓名
      amobile: "", //联系人电话
      emergencyContact: "", //紧急联系人姓名
      emergencyPhone: "", //紧急联系人电话
      // pageNumber: 1,
      // total: 0,
      navArray: ["周边多天", "周边一天", "国内线路", "国外线路"],
      value: "",
      idoptions: [
        {
          value: "0",
          label: "身份证",
        },
        {
          value: "1",
          label: "护照",
        },
        {
          value: "2",
          label: "其他",
        },
      ],
      //优惠类型
      discountAmount: [],
      discountvalue: 0,
      isdiscountlis: false,
      //基本信息
      gatherlist: "",
      line: "",
      lineSchedule: "",
      member: "",
      pricelist: "",
      serviceAgreements: "",

      placeId: "",

      allamount: 0,
      discountvalue: 0, //优惠折扣价格
      // discount: 0, //积分折扣的价格
      remark: "",

      checked: false,

      //微信支付弹框
      wxpayDialog: false,
      wxpaysrc: "",
      wechatamount: 0,

      //默认价格
      defaultpricelist: "",

      //支付方式:
      payMethodArray: ["微信", "支付宝"],
      payMethod: 0, //0微信 , 1支付宝

      //余位
      signStatus: '',
       shareId: '',
      // 集合地分数组
      gatherBranchList:[],
      // 用户的集合地数组
      userGatherList:[],
    };
  },
  components: {
    heads,
    homeFoots,
    wxpay,
    banners,
  },
  watch: {
    //通过监听人数和总金额判断
    number(val, newval) {
      this.finddiscount();
      this.getamount();
    },
    allamount(val01, newval01) {
      this.finddiscount();  

    },
  },
  computed: {
   // 默认地点列表
    defaultGatherList() {
      return this.$store.state.defaultGatherList;
    },
    maxPoints(){
      return this.lineSchedule.orderMaxPoints*this.number
    },
    memberInfo() {
      return this.$store.state.memberInfo;
    },
    discount() {
      return (this.pointvalue / 100).toFixed(2);
    },
    amount() {
      return (this.allamount - this.discountvalue - this.discount).toFixed(2);
    },
    number() {
      return this.touristInfo.length;
    },
    touristInfo: {
      get() {
        return this.$store.state.touristInfo;
      },
      set(value) {
        this.savetouristInfo(value);
      },
    },
  },
  methods: {
    fomateDate,
    timeFormat,
    // 集合地点变更
    placeChange(item){
        console.log("集合地变更")
        console.log(item)
        this.$forceUpdate();
    },
    handleIdNumberInput(idNumber, idType, index) {
      if (idType === "0") {
        const IdCardNumberReg = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/;
        if (IdCardNumberReg.test(idNumber)) {
          const birth =
            idNumber.substring(6, 10) +
            "-" +
            idNumber.substring(10, 12) +
            "-" +
            idNumber.substring(12, 14);
          this.touristInfo[index].birthday = birth;
          this.touristInfo[index].gender =
            parseInt(idNumber.substr(16, 1)) % 2 == 1 ? 0 : 1; //通过身份证倒数第二位是否为奇数识别性别
        }
      }
      // const IdCardNumberReg = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/;
      // if(IdCardNumberReg.test(idNumber) && this.form.id_types.indexOf('0') !== -1){
      //   const birth = idNumber.substring(6,10)+"-"+idNumber.substring(10,12)+"-"+idNumber.substring(12,14);
      //   this.form.birthday = birth;
      // }
    },

    //弹出游客信息
    pointchange() {
      if (!this.ispoint) {
        this.pointvalue = 0;
        this.discount = 0;
      }
    },

    //打开游客信息
    show() {
      this.dialogVisible = true;
      this.getFavoriteContacts();
      // this.touristInfo.map((res2, index2) => {
      //   this.pageArray.map((res3, index3) => {
      //     if (res2.id == res3.id) {
      //       res3.checked = true;
      //     } else {
      //       res3.checked = false;
      //     }
      //   });
      // });
    },
    //添加游客
    addtour() {
      this.isadd = !this.isadd;
      this.idType = "0";
      this.contactName = "";
      this.gender = "0";
      this.idNumber = "";
      this.birthday = "";
      this.isdefault = true;
      this.mobile = "";
      this.id = "";
    },
    //是否同意协议
    agree(index) {
      this.isAgreement = false;
      if (index == 1) {
        this.checked = false;
        this.reset();
      } else {
        if(this.line.isNeedSign == 1){
          this.isSignature = true;
          return
        }
        this.checked = true;
      }
    },
    //编辑游客
    toEditInfo(id) {
      this.id = id;
      this.isadd = true;
      this.findFavoriteContacts();
    },
    //通过id获取游客信息
    findFavoriteContacts() {
      axios
        .get(`/favoriteContacts/findFavoriteContacts.jhtml.jhtml`, {
          params: {
            id: this.id,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.idType = res.data.returnValue.idType == 0 ? "0" : "1";
            this.contactName = res.data.returnValue.contactName;
            this.gender = res.data.returnValue.gender == 0 ? "0" : "1";
            this.idNumber = res.data.returnValue.idNumber;
            this.birthday = res.data.returnValue.birthday;
            this.isdefault = res.data.returnValue.isdefault == 1 ? true : false;
            this.mobile = res.data.returnValue.mobile;
          } else {
            this.$message("系统繁忙，请稍后再试");
          }
        });
    },
     //由签名页返回界面
    back(){
      this.isSignature = false;
    },
    //重签
    reset(){
     this.showsignature = '';
     this.checked = false;
     this.signatureId = '';
     document.getElementById('signature').setAttribute('src',this.showsignature)
     this.$refs.esign.reset();
    },
    //提交签名
    submitSignature(){
        var that = this;
        this.$refs.esign.generate().then(res => {
        this.showsignature = res;
        document.getElementById('signature').setAttribute('src',this.showsignature)
        console.log(this.showsignature);
        console.log(typeof(res));
        let params = {
        code: res,
        id: this.signatureId,
        lineId: this.lineId,
        protocolId: this.serviceAgreements.id
      };
      axios
        .post("/mobile/signature/saveAndUpdate.jhtml", qs.stringify(params))  
        .then(res => {
          console.log(res)
           this.signatureId = res.data.returnValue.id;
           const message = res.data.returnValue.message;
           if(message === "签名上传成功!"){
              that.$message({
              message: message,
              type: 'success',
              duration:1500,
              center:true,
            })
            this.isSignature = false;
            this.checked = true;
           }else{
              that.$message({
              message:'签名上传失败~',
              type:"warning",
              duration:1500,
              center:true,
              });
           }
           return;
        })
        .catch(e => {
          that.$message({
              message:'签名上传失败~',
              type:"warning",
              duration:1500,
              center:true,
          });
          return;
        })
      }).catch(err => {
       console.log(err);
       that.$message({
              message:'签名不能为空',
              type:"warning",
              duration:1500,
              center:true,
        });
        return;
      })
    },
    //通过id删除游客信息
    deleteFavorites(id) {
      axios
        .get(`/favoriteContacts/deleteFavoriteContacts.jhtml`, {
          params: {
            id: id,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.getFavoriteContacts();
            this.$message("删除成功");
            // this.$store.dispatch("getTour");
          } else {
            this.$message("系统繁忙，请稍后再试~");
          }
        });
    },
    //保存游客信息
    editInfo() {
      let params = "";
      let url = "";
      if (!this.id) {
        params = {
          idType: this.idType,
          contactName: this.contactName,
          gender: this.gender,
          idNumber: this.idNumber,
          birthday: this.fomateDate(this.birthday),
          isdefault: this.isdefault ? 1 : 0,
          mobile: this.mobile,
        };
        url = "/favoriteContacts/addFavoriteContacts.jhtml";
      } else {
        params = {
          id: this.id,
          idType: this.idType,
          contactName: this.contactName,
          gender: this.gender,
          idNumber: this.idNumber,
          birthday: this.fomateDate(this.birthday),
          isdefault: this.isdefault ? 1 : 0,
          mobile: this.mobile,
        };
        url = "/favoriteContacts/updateFavoriteContacts.jhtml";
      }
      axios.post(url, qs.stringify(params)).then((res) => {
        if (res.data.success) {
          this.$message({
            message: "修改成功~",
            type: "success",
            duration: 1500,
            center: true,
          });
          this.isadd = false;
          this.getFavoriteContacts();

          // this.$store.dispatch("getMember");
        } else {
          this.$message({
            message: "系统繁忙，请稍后再试~",
            duration: 1500,
            type: "warning",
            center: true,
          });
        }
      });
    },
    handleCurrentChange(val) {
      this.getFavoriteContacts();
    },
    handleSizeChange(val) {
      console.log("当前页:" + val);
    },
    //关闭游客信息
    handleClose() {
      this.dialogVisible = false;
    },
    getAgreement() {
      if(this.touristInfo.length>0){
      this.isAgreement = true;
      }else{
            this.$message({
              type: "warning",
              message: "请至少填写一个游客",
              center: true,
              duration: 1500,
            });
            return;
      }
    },
    //关闭协议
    handleCloseAgreement() {
      this.isAgreement = false;
    },
    getFavoriteContacts() {
      axios
        .get(`/favoriteContacts/getFavoriteContacts.jhtml`, {
          params: {
            pageNumber: this.pageNumber,
            pageSize: 4,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.pageArray = res.data.returnValue.content;
            let list = [];
            let pageItem = {};
            // this.pageArray.map((res, index) => {
            //   if (res.isdefault == 1) {
            //     this.$set(res, "checked", true);
            //   } else {
            //     this.$set(res, "checked", false);
            //   }
            // });
            if (this.touristInfo.length == 1 && this.pageArray.length == 1) {
              this.$store.dispatch("getTour");
              this.userGatherList[0] = this.defaultGatherList();
              this.pageArray.map((res, index) => {
                if (res.isdefault == 1) {
                  this.$set(res, "checked", true);
                } else {
                  this.$set(res, "checked", false);
                }
              });
            }
            this.touristInfo.map((res2, index2) => {
              this.pageArray.map((res3, index3) => {
                if (res2.id == res3.id) {
                  res3.checked = true;
                }
              });
            });
            console.log("this.touristInfoss")
            console.log(this.touristInfo)
            this.total = res.data.returnValue.total;
          } else {
          }
        });
    },
    //获取到游客添加到信息
    checkRow(checked, item) {
      let pageItem = {};
      let pageList = [];
      if (checked) {
        pageItem.id = item.id;
        pageItem.name = item.contactName;
        pageItem.idcard = item.idNumber;
        pageItem.phone = item.mobile;
        pageItem.price = this.defaultpricelist;
        pageItem.idType = item.idType.toString();
        pageItem.gender = item.gender;
        pageItem.birthday = item.birthday;
        if(this.gatherBranchList && this.gatherBranchList.length>0){
          let gatherBranch = this.gatherBranchList[0].gatherBranch;
          console.log("checkRow -- gatherBranch")
          console.log(gatherBranch)
          pageItem.gatherPlaceId = gatherBranch[0].gatherPlaceId.id;
          let nextIndex = this.userGatherList.length;
          this.userGatherList[nextIndex] = this.nowGatherBranchList(this.defaultpricelist);
        }
        console.log(pageItem)
        if(this.touristInfo && this.touristInfo.length>0){
         let simpleTouristInfo = this.touristInfo[0]
         if(!simpleTouristInfo.name && !simpleTouristInfo.idcard && !simpleTouristInfo.phone && !simpleTouristInfo.birthday){
          this.touristInfo.splice(0,1,pageItem);
          return;
         }
        }
        this.touristInfo.push(pageItem);
        // if (this.touristInfo.length == 1 && this.pageArray.length == 1) {
        //     pageList.push(pageItem);
        //     this.touristInfo=pageList
        // }else{}
      } else {
        // if(this.touristInfo.length == 1){
        //   this.$message('至少要选择一名游客')
        //   return;
        // }else{
        let index = 0;
        for (let i = 0; i < this.touristInfo.length; i++) {
          if (item.id == this.touristInfo[i].id) {
            index = i;
            break;
          }
        }
        this.touristInfo.splice(index, 1);
        this.userGatherList.splice(index, 1);
      }
      console.log("finish")
      // }
    },

    //计算金额总数（不包括折扣）
    getamount() {
      let amount = 0;
      this.touristInfo.map((res01, index01) => {
        if (res01.price.linePrice) {
          amount += res01.price.linePrice;
        }
      });
      this.allamount = amount;
    },
    //获取优惠折扣
    getDisCount() {
      // this.discountAmount = this.discountlist[0].discount;
      if (this.discountAmount.thresholdNumber) {
        this.discountvalue = this.discountAmount.discountAmount * this.number;
      } else {
        this.discountvalue = this.discountAmount.discountAmount;
      }
      // this.discountvalue = this.discountAmount.discountAmount;
    },
    //判断优惠类型
    finddiscount() {
      this.ispay = false;
      axios
        .get(`/order/finddiscount.jhtml`, {
          params: {
            number: this.number,
            amount: this.allamount,
            id: this.lineScheduleId
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.discountlist = res.data.returnValue;
            if (this.discountlist.length > 0) {
              this.discountAmount = this.discountlist[0].discount;
              if (this.discountAmount.thresholdNumber) {
                this.discountvalue =
                  this.discountAmount.discountAmount * this.number;
                  console.log("this.discountvalue", this.discountvalue)
                  console.log("this.discountAmount.discountAmount", this.discountAmount.discountAmount)
                  console.log("this.number", this.number)
              } else {
                this.discountvalue = this.discountAmount.discountAmount;
              }
              // this.discountAmount = this.discountlist[0];
              // this.discountvalue = this.discountAmount.discountAmount;
              this.isdiscountlis = true;
            } else {
              this.discountAmount = [];
              this.discountvalue = 0;
              this.isdiscountlis = false;
            }
            this.ispay = true;
          }
        });
    },
    add() {
      let params = {
        id: "",
        name: "",
        idcard: "",
        phone: "",
        price: this.defaultpricelist,
        idType: "0",
        gender: 0,
        birthday: "",
      };
      let nextIndex = this.userGatherList.length;
      this.userGatherList[nextIndex] = this.nowGatherBranchList(this.defaultpricelist);
      if(this.userGatherList[nextIndex] && this.userGatherList[nextIndex].length>0){
        params.gatherPlaceId = this.userGatherList[nextIndex][0].gatherPlaceId.id
      }
      this.touristInfo.push(params);
      this.getamount();
    },
    del(index) {
      this.touristInfo.splice(index, 1);
      this.userGatherList.splice(index, 1);
      this.getamount();
    },

    //判断用户积分是否符合
    blur() {
      if (this.pointvalue > this.member.point) {
        this.$message("积分不足");
        this.pointvalue = 0;
        return;
      }
      if (this.pointvalue > parseInt(this.maxPoints)) {
        this.$message("填写积分不能超过订单最高积分");
        this.pointvalue = 0;
        return;
      }
      // this.discount = (this.pointvalue / 100).toFixed(2);
    },

    //获取订单基本信息
    orderInfo() {
      axios
        .get(`/order/orderInfo.jhtml`, {
          params: {
            lineScheduleId: this.lineScheduleId,
            lineId: this.lineId,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.orderInfoList = res.data.returnValue;
            //取出
            this.gatherlist = this.orderInfoList.gatherlist;
            if (this.gatherlist.length > 0) {
             this.gatherlist = this.gatherlist.filter((gather)=>{
              return gather.status!=0;
             })
             // 循环并将默认集合地点的调到前面
             let defaultGather = null;
             let newGatherlist = [];
             let undefaultGatherlist = [];
             console.log(this.gatherlist)
             for (let index = this.gatherlist.length-1; index >= 0 ;index--) {
               defaultGather = this.gatherlist[index];
               console.log("this.gatherlist")
               console.log(defaultGather)
              if(defaultGather.isDefault == 1){
                newGatherlist.unshift(defaultGather);
              }else{
                undefaultGatherlist.unshift(defaultGather)
              }
            }
            newGatherlist.push(...undefaultGatherlist);
            this.gatherlist = newGatherlist;
            this.placeId = this.gatherlist[0].gatherPlaceId.id;
            }
            this.line = this.orderInfoList.line;
            this.lineSchedule = this.orderInfoList.lineSchedule;
            this.member = this.orderInfoList.member;
            // 过滤掉冻结的价格
            this.pricelist = this.orderInfoList.pricelist.filter(
              (item, index, arr) => item.isEnable === 1
            );
            // 标记默认的价格并将他加入到列表一号位
            let defaultPrice = null;
            for (let index = 0; index < this.pricelist.length ;index++) {
               defaultPrice = this.pricelist[index];
               console.log(defaultPrice)
              if(defaultPrice.isDefault == 1){
                this.pricelist.splice(index,1);
                index--;
                break;
              }
            }
            if(defaultPrice && defaultPrice.isDefault == 1){
              this.pricelist.unshift(defaultPrice);
            }
            console.log("pricelist")         
            console.log(this.pricelist)         
            this.serviceAgreements = this.orderInfoList.serviceAgreements;
            // 处理集合地点
            if(this.pricelist.length > 0 ){
              let index = 0;
              this.pricelist.forEach(price => {
                let gatherBranch = [];
                if(price && this.gatherlist.length>0 && this.gatherlist){
                  this.gatherlist.forEach(place => {
                    if(place){
                      if(place.isSelectAll == 1){
                        gatherBranch.push(place);
                      }else if(place.linePriceId && price.id ==  place.linePriceId.id ){
                        gatherBranch.push(place);
                      }else{
                      // 不符合
                      }
                    }
                  });
                }
                this.gatherBranchList.push({
                  priceId:price.id,
                  gatherBranch:gatherBranch
                })
                 if(index == 0){
                  if(gatherBranch.length>0){
                    this.$store.commit("saveDefaultGatherList", gatherBranch);
                    this.$store.commit("saveDefaultGatherPlaceId", gatherBranch[0].gatherPlaceId.id);
                  }
                }
                index++;
              });
            }
            if (this.pricelist.length > 0  && this.touristInfo && this.touristInfo.length != 0) {
              this.touristInfo[0].price = this.pricelist[0];
              this.userGatherList[0] = this.nowGatherBranchList(this.touristInfo[0].price);
            }
            this.$store.commit("savedefaultpricelist", this.pricelist[0]);
            this.defaultpricelist = this.pricelist[0];
            this.getamount();
            // this.$forceUpdate();
          }
        });
    },
        // 获取当前的集合地列表
    nowGatherBranchList(price){
      let list = [];
      this.gatherBranchList.forEach(place => {
        if(price.id == place.priceId){
          list = place.gatherBranch;
        }
      })
      console.log("this.nowGatherBranchList")
      console.log(list)
      console.log(price)
      return list;
    },
    // 价格变动
    priceChange(item,index){
      this.userGatherList[index] = this.nowGatherBranchList(item.price);
      console.log("priceChange")
      console.log(item)
      if(this.userGatherList[index] && this.userGatherList[index].length>0){
        item.gatherPlaceId = this.userGatherList[index][0].gatherPlaceId.id
      }
      this.getamount(); 
      this.$forceUpdate();
    },
    //关闭微信支付二维码
    closeWxpay() {
      this.wxpayDialog = false;
    },
    //通过sn获取订单金额
    findorderbysn(sn) {
      axios
        .get(`/order/findorderbysn.jhtml`, {
          params: {
            sn: sn,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.wechatamount = res.data.returnValue.amount;
          } else {
            this.$message("系统繁忙，请稍后再试");
          }
        });
    },

    //wx支付 / 支付宝支付
    goWxpay(sn) {
       // 设置一个定时器
       this.checkWxpay(sn);
          try {
            this.wxpaysrc = "https://www.1778hw.com/m/pcCheckstand?"+"sn="+sn;
            this.wxpayDialog = true;
          } catch (error) {
            console.log(error);
       }
    },
    
    //微信二维码支付/支付宝二维码支付 校验
    checkWxpay(sn) {
      axios
        .get("/payment/pc/notify.jhtml", {
          params: {
            sn: sn,
          },
        })
        .then((res) => {
          if (res.data.type === "error") {
            if (this.wxpayDialog) {
              //3秒进行一次校验，当支付成功或者关闭弹框时停止校验
              const timer = setTimeout(() => {
                this.checkWxpay(sn);

                clearTimeout(timer); //释放定时器
              }, 3000);
            }
          } else {
            this.wxpayDialog = false;
            this.$message({
              type: "success",
              duration: 2000,
              message: "支付成功",
            });
            this.$router.replace({ path: "/userindex/1" });
          }
        });
    },

    //创建订单
    createOrder() {
      let touristInfoVo = this.touristInfo;
      if (touristInfoVo.length > 0) {
        for (let item of touristInfoVo) {
          if (
            item.name === "" ||
            item.idType === "" ||
            item.idcard === "" ||
            item.price === "" ||
            item.phone === "" ||
            item.birthday === ""||
            item.gatherPlaceId === ""
          ) {
            this.$message({
              type: "warning",
              message: "请将身份信息填写完整",
              center: true,
              duration: 1500,
            });
            return;
          }
        }
      }else{
            this.$message({
              type: "warning",
              message: "请至少填写一个游客",
              center: true,
              duration: 1500,
            });
            return;
        }
      // if (this.placeId == "") {
      //   this.$message({
      //     type: "warning",
      //     message: "请选择集合地点",
      //     center: true,
      //     duration: 1500,
      //   });
      //   return;
      // }
      if (this.signatureId == "" && this.line.isNeedSign == 1) {
        this.$message({
          message: "请阅读协议并签名",
          center: true,
          duration: 3000,
        });
        return;
      }
      if (this.aname == "" || this.amobile == "") {
        this.$message({
          type: "warning",
          message: "请填写完整的联系方式",
          center: true,
          duration: 1500,
        });
        return;
      }
      if(!/^((13[0-9])|(14[1|4|5|6|7|8|9])|(15([0|1|2|3|5|6|7|8|9]))|(16[2|5|6|7])|(17[0|1|2|3|5|6|7|8])|(18[0-9])|(19[1|8|9]))\d{8}$/.test(this.amobile)){
        this.$message({
          type: "error",
          message: "请填写正确的联系电话号码",
          center: true,
          duration: 1500,
        });
        return;
      }
      if(this.emergencyPhone != "" &&  !/^((13[0-9])|(14[1|4|5|6|7|8|9])|(15([0|1|2|3|5|6|7|8|9]))|(16[2|5|6|7])|(17[0|1|2|3|5|6|7|8])|(18[0-9])|(19[1|8|9]))\d{8}$/.test(this.emergencyPhone)){
        this.$message({
          type: "error",
          message: "请填写正确的紧急联系电话号码",
          center: true,
          duration: 1500,
        });
        return;
      }
      if (!this.checked) {
        this.$message({
          type: "warning",
          message: "请先阅读用户协议",
          center: true,
          duration: 1500,
        });
        return;
      }
      let roster = [];
      let rostervaule = {};
      this.touristInfo.map((res, index) => {
        let rosteritem = {};
        rosteritem.name = res.name;
        rosteritem.idType = res.idType;
        rosteritem.idNumber = res.idcard;
        rosteritem.linePriceId = res.price.id;
        rosteritem.phone = res.phone;
        rosteritem.gender = res.gender;
        rosteritem.birthday = res.birthday;
        rosteritem.gatherPlaceId = res.gatherPlaceId;
        roster.push(rosteritem);
      });
      rostervaule.roster = roster;
      // console.log(roster);
      let params = {
        aname: this.aname,
        amobile: this.amobile,
        emergencyContact: this.emergencyContact,
        emergencyPhone: this.emergencyPhone,
        ispoint: this.ispoint ? 1 : 0,
        pointvalue: this.pointvalue,
        lineScheduleId: this.lineScheduleId,
        lineId: this.lineId,
        paynum:this.number,
        amount: this.amount,
        discount: this.discountvalue,
        placeId: this.placeId,
        remark: this.remark,
        discountid: this.discountAmount.id,
         shareId: this.shareId,
        roster: JSON.stringify(rostervaule),
        signatureId: this.signatureId
      };
      axios
        .post("/order/createOrder.jhtml", qs.stringify(params))
        .then((res) => {
          if (res.data.success) {
            if(this.signStatus.indexOf('已满员') !== -1){
              this.$message({
                message: "活动已满员,已为您保留报名信息",
                type: "warning",
                duration: 1500,
                center: true
              })
            }else{
              this.$message({
                message: "报名成功~",
                type: "success",
                duration: 1500,
                center: true,
              });
              this.isCreateOrder = true;
              this.findorderbysn(res.data.returnValue.sn);
              this.goWxpay(res.data.returnValue.sn);
            }

            // this.$router.push({
            //   path: `/checkstand`,
            //   query: { sn: res.data.returnValue.sn }
            // });
          } else {
            this.$message({
              message: "系统繁忙，请稍后再试~",
              duration: 1500,
              type: "warning",
              center: true,
            });
          }
        });
    },
  },
  mounted() {},
  created() {
    console.log(this.$store.state.touristInfo)
    this.aname = this.memberInfo.username;
    this.amobile = this.memberInfo.mobile;
    // this.$store.dispatch("getTour");
    this.lineScheduleId = this.$route.query.lineScheduleId;
    this.lineId = this.$route.query.lineId;
        if (this.$route.query.shareId) {
      this.shareId = this.$route.query.shareId;
    }
    // console.log(this.$route.meta);
    this.signStatus = this.$route.query.signStatus;
    
    this.orderInfo();
    this.getFavoriteContacts();
  },
};
</script>

<style scoped>
.signUp {
  width: 100%;
  height: 100%;
  /* text-align: left; */
}
.container {
  text-align: left;
  margin-bottom: 20px;
}
.content {
  width: 100%;
}

.menber {
  width: 100%;
  /* height: 240px; */
  box-shadow: 0px 0px 6px #c7c6c6;
  margin: 20px auto;
  border-radius: 6px;
  padding: 20px;
  box-sizing: border-box;
}
.menber .linetime-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* text-align: left; */
  padding: 20px 0 40px 0;
}
.menber .linetime-box > .name {
  flex: 1;
  text-align: left;
}
.menber .linetime-box > .linetime {
  display: inline-block;
}
.usually {
  /* height: 50px; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 25px;
}
.usually .text {
  color: #007741;
  font-weight: bold;
}
.usually .btn {
  text-align: center;
  background: #007741;
  color: #fff;
  width: 100px;
  height: 30px;
  line-height: 30px;
  border-radius: 8px;
  cursor: pointer;
}
.usually .btn:hover {
  background: #069e5a;
}
.menber-list {
  padding: 10px 0;
}
.add-aontent {
  display: flex;
  margin-bottom: 20px;
}
.add-list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 80%;
  border-bottom: 6px solid #eeeeee;
}
.itemright {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
}
.reduse {
  cursor: pointer;
  display: block;
  width: 80px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  background: #cccccc;
  border-radius: 6px;
  color: #ffffff;
}
.menber-item {
  width: 100%;
  display: flex;
  box-sizing: border-box;
  padding: 10px 0;
}
.add-item {
  display: flex;
  width: 46%;
  margin-bottom: 20px;
}
.left-text {
  background-color: #f5f7fa;
  color: #909399;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 0 20px;
  line-height: 40px;
  width: 100px;
  height: 40px;
  font-size: 14px;
  white-space: nowrap;
}
.right-text {
  flex: 1;
}
.info {
  flex: 1;
  height: 40px;
  line-height: 40px;
  text-align: right;
  margin-right: 30px;
  font-size: 14px;
  color: #999999;
}
.select {
  position: relative;
  margin-left: 26px;
  margin-right: 4px;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 5px;
}
.select-active {
  background: #007741;
  border: 1px solid #007741;
  color: #fff;
}
.add-text {
  width: 160px;
  font-size: 16px;
  text-align: center;
}
.menber-item .col-8 {
  width: 80%;
}
.menber-item .col-9 {
  width: 90%;
}
.menber-item .el-input {
  padding-right: 18px;
}
.menber-list .add-items {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.menber-list .del {
  min-width: 30px;
}
.menber-list .del > .el-icon-remove {
  font-size: 24px;
  line-height: 54px;
  color: red;
  cursor: pointer;
}
.menber-item .el-input {
  margin: 12px 0;
}
.menber-item .el-dropdown {
  color: #909399;
}
.signinfo {
  display: flex;
  justify-content: space-between;
  /* flex-wrap: wrap; */
  border-bottom: 1px solid #eeeeee;
}
.item {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px auto;
  width: 21%;
}
.span01 {
  width: 6%;
}
.span05 {
  flex: 1;
}
.item-long {
  width: 100%;
  margin: 20px auto;
}
.left {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding-bottom: 30px;
  border-bottom: 1px solid #cccccc;
}
.names {
  display: block;
  width: 100%;
  text-align: center;
}
.name {
  text-align: right;
  display: block;
  width: 120px;
  margin-right: 20px;
  color: #666666;
}
.men-img {
  width: 80px;
  height: 80px;
  border-radius: 100%;
}
.buttom {
  cursor: pointer;
  position: absolute;
  right: 0;
  width: 80px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  background: #007741;
  color: #ffffff;
  font-size: 14px;
}
.buttom:hover {
  background: #069e5a;
}
.buttoms:hover {
  background: #069e5a;
}
.buttoms {
  cursor: pointer;
  width: 80px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  background: #007741;
  color: #ffffff;
  font-size: 14px;
  margin: 10px auto;
}
.inputs {
  border: 1px solid #cccccc;
  padding: 5px;
  border-radius: 4px;
  color: #666666;
}
.price {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 60px;
}
.price-left {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin-left: 10px; */
}
.price-lists {
  width: 100%;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 20px;
  border: 1px solid #eeeeee;
  align-items: center;
  flex-wrap: wrap;
  margin: 10px;
}
.price-items {
  width: 48%;
  margin-bottom: 20px;
}
.price-list {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.labels {
  color: #007741;
  font-weight: bold;
}
.label {
  color: #666;
  display: inline-block;
  margin-right: 10px;
}
.col {
  color: red;
  font-size: 22px;
  font-weight: bold;
}
.fa-weixin {
  color: #24a838;
  margin-right: 10px;
}
.agreement {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}
.agreement-right {
  display: flex;
  align-items: center;
}
.agreement .pay-method {
  display: flex;
  align-items: center;
}
.agreement .pay-method > img {
  width: 36px;
}
.total {
  display: block;
  margin-right: 20px;
}
.other-options {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.other-item {
  width: 46%;
  margin-bottom: 20px;
}

.textarea {
  /* margin-top: 20px; */
}

/* 常用联系人 */
.tour-content {
  /* height: 360px; */
  /* overflow-y: auto; */
}
.edit-info {
  cursor: pointer;
  display: block;
  width: 40px;
  text-align: center;
  line-height: 20px;
  height: 20px;
  font-size: 12px;
  border: 1px solid #6ed5a6;
  background: #6ed5a6;
  border-radius: 6px;
  color: #ffffff;
  margin-left: 20px;
}
.list {
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eeeeee;
}
.info-left {
  width: 10%;
}
.touitem {
  width: 90%;
  padding: 10px;
  box-sizing: border-box;
}
.tou-top {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.namess {
  display: block;
  margin: 0 10px;
}
.fa-user-circle-o {
  color: #6ed5a6;
}
.fa-mars {
  color: #0a79b0;
}

.fa-venus {
  color: #f156d6;
}
.default {
  font-size: 12px;
  display: inline-block;
  /* width: 100px; */
  text-align: center;
  padding: 2px 8px;
  background: #0a79b0;
  color: #ffffff;
  margin-left: 10px;
  border-radius: 16px;
}
.top-left {
  display: flex;
  align-items: center;
  /* width: 30%; */
}
.top-right {
  display: flex;
  align-items: center;
}
.tou-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn-item {
  width: 100%;
  height: 30px;
  position: relative;
}
.posi {
  position: absolute;
  display: flex;
  align-items: center;
  top: 10px;
  /* height: 30px; */
  right: 0px;
}
.btn1 {
  cursor: pointer;
  display: block;
  width: 40px;
  text-align: center;
  line-height: 20px;
  height: 20px;
  font-size: 12px;
  border: 1px solid #6ed5a6;
  border-radius: 6px;
  color: #6ed5a6;
  margin-left: 20px;
}
/* 游客编辑 */
.edit {
  width: 100%;
  margin: 10px 0;
}
.edit-item {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.edit-text {
  width: 100px;
}
.diacontent {
  height: 400px;
  overflow-y: auto;
}
</style>
<style>
.el-input-group__append,
.el-input-group__prepend {
  width: 100px !important;
}
.add-price .el-input__inner {
  pointer-events: none;
}
.disbtnlist {
        display: flex;
}
.dis-btn {
  margin: 0 auto;
  text-align: center;
  width: 80px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  background: #007741;
  color: #fff;
  border: 1px solid #eeeeee;
  cursor: pointer;
}

.btn-col {
  background: red;
}

.btn-reverse {
  margin: 0 auto;
  text-align: center;
    width: 80px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  color: #007741;
  border: 1px solid #007741;
  background-color: #fff;
  cursor: pointer;
}

.el-checkbox__input.is-disabled .el-checkbox__inner{
  cursor: pointer !important;
}
.signatureStyle-content{
  position: relative;
  margin-bottom: 20px;
}
#signature{
  border: 1px solid #DCDFE6;
  position: absolute;
  top:40px;
  left:0px;
  width: 200px;
  height: 80px;
 
  border-radius: 4px;
}
.writeStyle{
  border: 1px dashed #999;
}
.address-label{
  width: 100px !important;
  background-color: #F5F7FA;
  color: #909399;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  padding: 0 20px;
  width: 1px;
  white-space: nowrap;
  border-right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  line-height: 35px;
  font-size: 14px;
}
.address .el-input--suffix .el-input__inner {
    padding-right: 80px;
}
</style>


// WEBPACK FOOTER //
// src/components/activityview/signUp.vue